import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { IState } from '../shared/models/state';
import { GET_CALL_HISTORY_FAILURE, GET_CALL_HISTORY_SUCCESS, GetCallHistoryAction } from './call-history.actions';
import { map, take } from 'rxjs/operators';

@Injectable()
export class CallHistoryResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.dispatch(new GetCallHistoryAction({}));
    return this.action$.pipe(
      ofType(GET_CALL_HISTORY_SUCCESS, GET_CALL_HISTORY_FAILURE),
      map((action: any) => {
        console.log('RESOLVE action: ', action.payload);
        return action.payload;
      }),
      take(1)
    );
  }
}
